import { Avatar } from "@chakra-ui/react";
import { Tooltip } from "../components/ui/tooltip";
import { Fragment } from "react";
import { Exercise } from "../models/Exercise";
import Typhography from "../shared/Typhography/Typhography";
import { GroupExercise } from "../models/GroupExercise";
import { truncateString } from "./functions";
import SuccessIcon from "../assets/icons/SuccessIcon";
import WarningIcon from "../assets/icons/WarningIcon";
import RepeatIcon from "../assets/icons/RepeatIcon";
import dayjs from "dayjs";
import { CalendarIcon } from "@phosphor-icons/react";
import classNames from "classnames";

export const renderTagsTable = (tags?: GroupExercise[]) => {
  if (!tags) return <Fragment />;
  const tagsString = tags.map(({ name }) => `#${name}`);
  if (tags.length > 3) {
    return (
      <>
        <Typhography type="span" size="medium-14">
          {`${[...tagsString].splice(0, 3).join(" ")}`}
        </Typhography>
        <Tooltip content={tagsString.join(" ")} showArrow>
          <span className="text-medium-14 ms-1">+{tags.length - 3}</span>
        </Tooltip>
      </>
    );
  }
  return <Typhography size="medium-14">{tagsString.join(" ")}</Typhography>;
};

export const renderDescriptionTable = (description?: string) =>
  description && description.length > 60 ? (
    <Tooltip content={description} showArrow>
      <p className="text-regular-14 text__description__exercises__table">
        {truncateString(description, 300)}
      </p>
    </Tooltip>
  ) : (
    <Typhography size="regular-14">{description}</Typhography>
  );

export const renderStatusActivity = (days: string[]) => {
  const formattedDays = days.map((day) => dayjs(day));
  const today = dayjs();
  const [startDay] = formattedDays;
  let status: "done" | "skipped" | "planned" | "ongoing" = "planned";
  const endDay = formattedDays[formattedDays.length - 1];
  if (today.isBefore(startDay)) {
    status = "planned";
  } else if (today.isAfter(startDay) && today.isBefore(endDay)) {
    status = "ongoing";
  }

  const { icon, text } = {
    done: {
      icon: <SuccessIcon className="done-icon" />,
      text: "Done",
    },
    skipped: {
      icon: <WarningIcon className="warning-icon" />,
      text: "Skipped",
    },
    planned: {
      icon: <CalendarIcon className="planned-icon" />,
      text: "Planned",
    },
    ongoing: {
      icon: <RepeatIcon className="ongoing-icon" />,
      text: "Ongoing...",
    },
  }[status];
  return (
    <div className="container-status-activity status-a d-flex align-items-center gap-1">
      {icon}
      <Typhography>{text}</Typhography>
    </div>
  );
};

export const renderNameUser = (_: any, record: any) => {
  const fullName = `${record.firstName} ${record.lastName}`;
  return (
    <div className="d-flex align-items-center gap-2 ">
      <Avatar.Root
        className={classNames("user-table-container", {
          "image-user-container": !!record.image,
        })}
      >
        <Avatar.Fallback name={fullName} />
        <Avatar.Image
          src={
            record.image
              ? `${process.env.REACT_APP_BASE_URL_IMAGE}${record.image.image}`
              : undefined
          }
        />
      </Avatar.Root>
      <div className="d-flex flex-column gap-2">
        <Typhography size="bold-14">{fullName}</Typhography>
        <Typhography size="medium-12" className={"label-email"}>
          {record.email}
        </Typhography>
      </div>
    </div>
  );
};
